module.exports = __webpack_public_path__ + "static/media/gGivesTeam.9d7ac6d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/gGivesTeam.png
// module id = 216
// module chunks = 0